export default __webpack_public_path__ + "assets/images/munim-spinner.3412ff04.gif";